import React, { Component } from 'react';

import AdminLayout from './layout';

import { adminDashboard, schoolCount,tuitionCount, preschoolCount, afaCount, learningcampCount} from '../../API/FetchCall';

import { Chart } from 'chart.js';

const doughnutPieOptions = {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          }
        };    

const optionsN = {
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            }
        }],

    }
}

class dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          school_data: [],
          schoolcounts:0,
          tuitioncounts:0,
          preschoolcount:0,
          afacount:0,
          learningcampscount:0
        };
    }

    componentDidMount() {

        let req = {
            url: 'school_data'
        };

        adminDashboard(JSON.stringify(req)).then(response => {
            if (response.status === 1) {
                this.setSchoolChart(response.result);
            }
        });


        schoolCount().then(response=>{

            this.setState({schoolcounts:response.total});

        })

        tuitionCount().then(response=>{

            this.setState({tuitioncounts:response.total});

        })

        preschoolCount().then(response=>{

            this.setState({preschoolcount:response.total});

        })        

        afaCount().then(response=>{

            this.setState({afacount:response.total});

        })
      
        learningcampCount().then(response=>{

            this.setState({learningcampscount:response.total});

        })


        req.url = 'like_follow_chart';
        adminDashboard(JSON.stringify(req)).then(response => {

            if (response.status === 1) {
                this.setLike(response.result);
            }
        });


        req.url = 'vistors_chart';
        adminDashboard(JSON.stringify(req)).then(response => {

            if (response.status === 1) {
                this.setVisitors(response.result);
            }
        });


        this.setState({user_name:this.state.auth_data.user_name, role:this.state.auth_data.role});   


    }


    setVisitors = (data) => {

        var ctx = document.getElementById('barChartVisitors');
        new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }    

    setLike = (data) => {

        var ctx = document.getElementById('barChartLikeFollows');
        new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }

    setAfterschoolChart = (data) => {

        var ctx = document.getElementById('afterschoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }    

    setTuitionChart = (data) => {

        var ctx = document.getElementById('tuitionChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setSchoolChart = (data) => {

        var ctx = document.getElementById('schoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });
    }

    setPreschoolChart = (data) => {

        var ctx = document.getElementById('preschoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    } 


    setcampChart = (data) => {

        var ctx = document.getElementById('campChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setcommunityChart = (data) => {

        var ctx = document.getElementById('communityChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setbirthdayChart = (data) => {

        var ctx = document.getElementById('birthdayChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }        


    render() {

        return (
          <React.Fragment>
          <AdminLayout>
                    
            <div class="row  mt-3">
           

             {this.state.role===1 && (
             <div class="col-lg-12 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                     <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Visual Reports</h4>
                     </div>
                     <div class="row">
                      <div class="col-12">
                        <div class="row">
                            <div class="col-md-3 mb-3">
                              <button type="button" class="btn btn-primary w-100 align-items-stretch d-flex">
                              <div class="text text-left py-2">
                              <h2>{this.state.schoolcounts}</h2>
                              <div><span class="vr_btntext">Schools</span><span class="text-right"><a class="reportlinks" href="/dashboard/dashboard/bewisetotal">click to view more reports</a></span></div>
                              </div>
                              </button>
                            </div>
                             <div class="col-md-3 mb-3">
                              <button type="button" class="btn btn-primary w-100 align-items-stretch d-flex">
                              <div class="text text-left py-2">
                              <h2>{this.state.tuitioncounts}</h2>
                              <div><span class="vr_btntext">Tuitions</span><span class="text-right"><a class="reportlinks" href="/dashboard/dashboard/bewisetotal">click to view more reports</a></span></div>
                              </div>
                              </button>
                            </div>

                            <div class="col-md-3 mb-3">
                              <button type="button" class="btn btn-primary w-100 align-items-stretch d-flex">
                              <div class="text text-left py-2">
                              <h2>{this.state.preschoolcount}</h2>
                              <div><span class="vr_btntext">Preschools</span><span class="text-right"><a class="reportlinks" href="/dashboard/dashboard/bewisetotal">click to view more reports</a></span></div>
                              </div>
                              </button>
                            </div>
                            <div class="col-md-3 mb-3">
                              <button type="button" class="btn btn-primary w-100 align-items-stretch d-flex">
                              <div class="text text-left py-2">
                              <h2>{this.state.afacount}</h2>
                              <div><span class="vr_btntext">Afterschool Activities</span><span class="text-right"><a class="reportlinks" href="/dashboard/dashboard/bewisetotal">click to view more reports</a></span></div>
                              </div>
                              </button>
                            </div>
                            <div class="col-md-3 mb-3">
                              <button type="button" class="btn btn-primary w-100 align-items-stretch d-flex">
                              <div class="text text-left py-2">
                              <h2>{this.state.learningcampscount}</h2>
                              <div><span class="vr_btntext">Learning Camps</span><span class="text-right"><a class="reportlinks" href="/dashboard/dashboard/bewisetotal">click to view more reports</a></span></div>
                              </div>
                              </button>
                            </div>
                          </div>  
                      </div>
                    </div>
                   </div>
                </div>
             </div>

              ) }
               
              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Visitors</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <canvas id="barChartVisitors"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              

              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Likes & Follows</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <canvas id="barChartLikeFollows"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {this.state.role===1 && (

              <div class="col-lg-12 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Waiting for Approvals</h4>
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <tbody>

                          
                          <tr>
                            <td>
                              <div class="d-flex">
                                
                                <div>
                                  <div> Testes article</div>
                                  <div class="font-weight-bold mt-1">Article</div>
                                </div>
                              </div>
                            </td>
                            <td>
                              By
                              <div class="font-weight-bold  mt-1">Udya</div>
                            </td>
                            <td>
                              Status
                              <div class="font-weight-bold text-success  mt-1">waiting for approval</div>
                            </td>
                            <td>
                              Created Date
                              <div class="font-weight-bold  mt-1">31 Jan 2023</div>
                            </td>
                            <td>
                              <a href="/cms/insights/edit-blog/8" class="btn btn-sm btn-secondary">action</a>
                            </td>
                          </tr>
                           
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              )}


              {this.state.role===3 && (

              <div class="col-lg-12 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Latest Leads</h4>
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <tbody>

                          
                          <tr>
                            <td>
                              <div class="d-flex">
                                
                                <div>
                                  <div> From : Test user</div>
                                  <div class="font-weight-bold mt-1">Parent</div>
                                </div>
                              </div>
                            </td>
                             
                          
                            <td>
                              Created Date
                              <div class="font-weight-bold  mt-1">31 Jan 2023</div>
                            </td>
                            <td>
                              <a href="#" class="btn btn-sm btn-secondary">view</a>
                            </td>
                          </tr>
                           
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              )}


            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default dashboard;


// WEBPACK FOOTER //
// ./src/components/bewise/dashboard.jsx